import {Component, OnInit} from '@angular/core';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';
import {CommandService} from '@core/services/command.service';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Api} from '@shared/constants/common-field.constants';
import {take} from 'rxjs/operators';
import {defaultAvatarStyle, roleType, defaultRolesId} from '@features/security/security.constants';

@Component({
    standalone: false,
    selector: 'app-manage-user-roles',
  templateUrl: './manage-user-roles.component.html',
  styleUrl: './manage-user-roles.component.scss'
})
export class ManageUserRolesComponent extends DialogDefinitionEditorBase implements OnInit{
  platformUserId: string;
  platformUser: any;
  roleType = roleType;
  defaultStyle = defaultAvatarStyle;
  isCurrentUser: boolean;
  isCurrentUserAdmin: boolean;
  defaultRolesId = defaultRolesId;
  workspaceId: string;
  constructor(private commandService: CommandService,
              private platformQueryService: PlatformQueryService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.init();
  }

  private getPlatformUser() {
    const platformUserQuery = new PlatformQuery();
    platformUserQuery.name = 'PlatformUserQuery';
    platformUserQuery.api = Api.Security;
    platformUserQuery.fieldValues['PlatformUserId'] = this.platformUserId;
    platformUserQuery.fieldValues['SourceWorkspaceId'] = this.workspaceId;
    this.platformQueryService.executeQuery(platformUserQuery).pipe(take(1)).subscribe(response => {
      console.log('platform user query response: ', response);
      this.platformUser = response.fieldValues['PlatformUser'];
      this.isCurrentUser = response.fieldValues['IsCurrentUser'];
      this.isCurrentUserAdmin = response.fieldValues['IsCurrentUserAdmin'];
    });
  }

  private init() {
    this.platformUserId = this.getPlatformUserId();
    this.workspaceId = this.getWorkspaceId();
    this.getPlatformUser();
  }

  private getPlatformUserId() {
    return this.dialogField.options.find(o => o.id === 'PlatformUserId').text;
  }

  onRemoveRole(role: any) {
    if (!this.dialogField.value) {
      this.dialogField.value = [];
    }
    this.dialogField.value.push(role.id);
    this.dynamicFormControl.setValue(this.dialogField.value);
    this.removeRoleFromUser(role);
  }

  private removeRoleFromUser(role: any) {
    const index = this.platformUser.roles.indexOf(role);
    if (index > -1) {
      this.platformUser.roles.splice(index, 1);
    }
  }

  userHasAssignedRoles() {
    return this.platformUser?.roles.some(role => role.type !== roleType.DynamicRole);
  }

  userHasDynamicRoles() {
    return this.platformUser?.roles.some(role => role.type === roleType.DynamicRole);
  }

  GetAssignedRoles(roles: any) {
    return roles.filter(r => r.type !== roleType.DynamicRole);
  }

  GetDynamicRoles(roles: any) {
    return roles.filter(r => r.type === roleType.DynamicRole);
  }

  IsRemoveButtonDisabled(role: any) {
    const isAdministratorRole = role.id.includes(defaultRolesId.Administrator);

    const isDisables = (this.isCurrentUser && isAdministratorRole) ||
                        (!this.isCurrentUserAdmin && isAdministratorRole) ||
                        this.platformUser?.roles.filter(r => r.type !== roleType.DynamicRole).length == 1
                        ;
    return isDisables;
  }

  private getWorkspaceId() {
    if (this.dialogField.options[0].tags.length > 0) {
        return this.dialogField.options[0].tags[0];
    }
  }
}
